import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { httpOptions, serviceConstants, formOptions } from '../../constants/service.constants';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EapSummaryService {

  constructor(private http: HttpClient) {

  }


  ///////////// //////////////////////
  DeleteRecord(Url: any): Observable<any> {
    return this.http.get(serviceConstants.apiURL + Url, httpOptions);
  }
  getGeneralInformation(Url: any): Observable<any> {
    return this.http.get(serviceConstants.apiURL + Url, httpOptions);
  }
  SaveIstGeneralInfo(url: any, formData: any): Observable<any> {
    return this.http.post(serviceConstants.apiURL + url, formData, httpOptions);
  }

  getApplicationSummary(url: any): Observable<any> {
    return this.http.get(serviceConstants.apiURL + url, httpOptions);
  }
  getISTSearchSummary(url: any, formData: any): Observable<any> {
    return this.http.post(serviceConstants.apiURL + url, formData, httpOptions);
  }
  getISTApplicationSummary(url: any): Observable<any> {
    return this.http.get(serviceConstants.apiURL + url, httpOptions);
  }
  getSummaryData(url: any) {
    return this.http.get(serviceConstants.apiURL + url, httpOptions);
  }
  fetchSearchData(url: any, body: any) {
    return this.http.post(serviceConstants.apiURL + url, body, httpOptions);
  }
  Insert(url: any, body: any): Observable<any> {
    return this.http.post(serviceConstants.apiURL + url, body, httpOptions);
  }
  FilesInsert(url: any, body: any): Observable<any> {
    return this.http.post(serviceConstants.apiURL + url, body, formOptions);
  }
  masterData(url: any) {
    return this.http.get(serviceConstants.apiURL + url, httpOptions);
  }

  getScreenDataForEdit(url: any) {
    return this.http.get(serviceConstants.apiURL + url, httpOptions);
  }
  UpdateStatus(url: any) {
    return this.http.get(serviceConstants.apiURL + url, httpOptions);
  }

}
